module.exports = __webpack_public_path__ + "static/media/view descriptive report.778f844c.svg";